import React from 'react';

export const ChanelBottomBanner = () => (
  <div id='bottom-chanel-banner' className='row py-2'>
    <div id='chanel-e-logo-image-container' className='py-2'>
      <img
        id='chanel-e-logo'
        src={'http://dimg.dillards.com/is/image/DillardsZoom/chanel%2De%2Dlogo?$chanelNav$'}
        height='140'
        width='140'
        alt={'chanel authorized retailer'}
      />
    </div>
  </div>
);

export default ChanelBottomBanner;
